import {
  SessionTemplateQuestionDto,
  SessionTemplateQuestionsDto,
} from '@beyou/app/core/dto/sessions/session-template-questions.dto';
import {
  SessionQuestionKind,
  SessionTemplateQuestion,
  SessionTemplateQuestions,
} from '@beyou/app/core/models/sessions/session-template-questions.model';

export class SessionTemplateQuestionsMapper {
  public static toModel(dto: SessionTemplateQuestionsDto): SessionTemplateQuestions {
    return {
      sessionTemplateId: dto.session_template_id,
      userId: dto.user_id,
      languageId: dto.language_id,
      smartSurveyId: dto.smart_survey_id,
      questions: (dto.questions ?? [])
        .map((q) => this.toQuestion(q))
        .sort((a, b) => a.position - b.position),
    };
  }

  public static toQuestion(dto: SessionTemplateQuestionDto): SessionTemplateQuestion {
    return {
      key: dto.key,
      kind: dto.kind as SessionQuestionKind,
      question: dto.question,
      constraints: dto.constraints ?? '',
      position: dto.position,
      answer: dto.answer ?? '',
      placeholderId: dto.placeholder_id,
      placeholderGroupId: dto.placeholder_group_id,
      placeholderGroupName: dto.placeholder_group_name,
      answerId: dto.answer_id,
    };
  }
}
